import { render, staticRenderFns } from "./Topico.vue?vue&type=template&id=2bd5177d&scoped=true"
import script from "./Topico.vue?vue&type=script&lang=js"
export * from "./Topico.vue?vue&type=script&lang=js"
import style0 from "./Topico.vue?vue&type=style&index=0&id=2bd5177d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd5177d",
  null
  
)

export default component.exports